import { render } from "./identification-data.vue?vue&type=template&id=7f59c0c2&scoped=true&ts=true"
import script from "./identification-data.vue?vue&type=script&lang=ts"
export * from "./identification-data.vue?vue&type=script&lang=ts"

import "./identification-data.vue?vue&type=style&index=0&id=7f59c0c2&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f59c0c2"]])

export default __exports__